export enum SectionNameEnum {
  allAboutPrizm = 'Все о Prizm',
  howToWork = 'Как работать с Prizm',
  forZIIoT = 'Prizm для ZIIoT',
  guidelines = 'Гайдлайны',
  components = 'Компоненты',
  charts = 'Графики',
  tools = 'Инструменты',
}
